export default __webpack_public_path__ + "static/media/wadex_wallet_img.b2848bb7.jpg";